import React from "react";

const Corsi = () => (
  <div className="elefante">
    <div>
      <div className="Corsi">
        <h1 className="Titolo">I Nostri Corsi</h1>

        <div className="due">
          <div className="box">
            <h2>Space Coding</h2>
            <div className="row">
              <div className="column">
                <p>Età</p>
                <p className="p-grey">
                  <strong>8-13 anni</strong>
                </p>
              </div>
              <hr />
              <div className="column">
                <p>Durata</p>
                <p className="p-grey">
                  <strong>8 settimane</strong>
                </p>
              </div>
              <hr />
              <div className="column">
                <p>Orario</p>
                <p className="p-grey">
                  <strong>18.0-20.00</strong>
                </p>
              </div>
              <hr />
              <div className="column">
                <p>Programmi</p>
                <p className="p-grey">
                  <strong>Scratch</strong>
                </p>
              </div>
              <hr />
              <div className="column">
                <p>Luogo</p>
                <p className="p-grey">
                  <strong>
                    Milano, Wild Code School <br />
                    Via Carlo Farini, 32
                  </strong>
                </p>
              </div>
              <hr />
              <div className="column">
                <p>Progetto Finale</p>
              </div>
            </div>
          </div>

          <div className="box">
            <h2>Space Coding</h2>
            <div className="row">
              <div className="column">
                <p>Età</p>
                <p className="p-grey">
                  <strong>8-13 anni</strong>
                </p>
              </div>
              <hr />
              <div className="column">
                <p>Durata</p>
                <p className="p-grey">
                  <strong>8 settimane</strong>
                </p>
              </div>
              <hr />
              <div className="column">
                <p>Orario</p>
                <p className="p-grey">
                  <strong>18.0-20.00</strong>
                </p>
              </div>
              <hr />
              <div className="column">
                <p>Programmi</p>
                <p className="p-grey">
                  <strong>Tinkercad</strong>
                </p>
              </div>
              <hr />
              <div className="column">
                <p>Luogo</p>
                <p className="p-grey">
                  <strong>
                    Milano, Wild Code School <br />
                    Via Carlo Farini, 32
                  </strong>
                </p>
              </div>
              <hr />
              <div className="column">
                <p>Progetto Finale</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="esaurimento">
      <div className="grid">
        <div className="grid-item">
          <button type="button">Iscrizione</button>
          <p>
            Il corso di coding di Kiddos Space Coding ha l'obiettivodi
            avvicinare, con semplicità, bambini e ragazzi al mondodella
            programmazione. Spiegando in modo intuitivo edivertente cosa sia un
            linguaggio, e attraverso unfantastico viaggio intergalattico,
            rendiamo ragazze eragazzi autonomi nella creazione e nel
            ragionamento delloro codice personale, stimolandone quindi la
            creatività.
          </p>
        </div>

        <div className="grid-item">
          <button type="button">Iscrizione</button>
          <p>
            Il corso di stampa 3d Kiddos 3D Odyssey ha l'obiettivodi mostrare a
            bambini e ragazzi uno degli esempi piùpratici di integrazione di
            digitale e analogico.Approfondendo i concetti di design e
            prototipazione rapida,e attraverso un'avventura ai confini
            dell'universo, ipartecipanti potranno realizzare i loro UFO
            personalizzati edare forma alla loro creatività e voglia di
            sperimentare.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default Corsi;
